<template>
  <LazyCarousel
    :title="title"
    :size="size"
    :items="products">
    <template #item="{ item }">
      <ProductCard
        disabled-swipe
        :product="item"
        :to="getProductRoute({product: item, lang: $lang})" />
    </template>
  </LazyCarousel>
</template>
<script setup>
import getProductRoute from '~/helpers/get-product-route'
const { $lang } = useNuxtApp()
defineProps({
  title: {
    type: String,
    default: null
  },
  products: {
    type: [Array, Object],
    default: null
  },
  size: {
    type: String,
    default: 'medium',
    validator: value => ['small', 'medium-small', 'medium'].includes(value)
  }
})
</script>
